import { Box, Flex } from 'reflexbox';
import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from '../../../healtheraComponents';

const BranchStaticField = ({ labelSize = 17, label, value, onValueClick, ...otherProps }) => {
  return (
    <Flex align="center" justify="space-between" style={{marginTop:0}} {...otherProps}>
      <Label size={labelSize}>{label}</Label>
      <Value editablestyles={onValueClick ? 'true' : 'false'} onClick={onValueClick}>
        {value}
      </Value>
    </Flex>
  );
};

const getLabelStyles = props => {
  const { size } = props;
  let fontWeight = 600;

  if (size > 20) {
    fontWeight = 700;
  }

  return css`
    font-size: ${props.size}px;
    font-weight: ${fontWeight};
  `;
};

const editableValueMixin = css`
  cursor: pointer;
  border: 1px solid #DDDDDD;

  &:hover {
    background-color: white;
    border-color: grey;
  }
`;

const getValueStyles = props => {
  if (props.editablestyles === 'true') return editableValueMixin;
};

const Label = styled(Box)`
  ${getLabelStyles}
`;

const Value = styled(Box)`
  padding: 8px 16px;
  color: ${colors.DARK};
  font-size: 17px;
  font-weight: 600;
  line-height: 20px;

  background-color: ${colors.FADED_LIGHT};

  ${getValueStyles}
`;

export default BranchStaticField;
